// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Gaid","gfeWrapper":"CalendarEvent_gfeWrapper__1jpD8"};